var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{class:{
    message: true,
    info: _vm.type === 'info',
    success: _vm.type === 'success',
    warning: _vm.type === 'warning',
    error: _vm.type === 'error',
  },attrs:{"data-id":_vm.id}},[_c('header',{on:{"click":function($event){return _vm.closeMessage(_vm.id)}}},[_c('span',{staticClass:"header-span"},[_vm._v(" "+_vm._s(_vm.getTitle)+" ")]),_c('div',{staticClass:"icons"},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)]),(_vm.title)?_c('main',[_c('hr'),_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }